import React, { useState, useEffect } from "react";
import Grid from "@material-ui/core/Grid";
import Card from "./TokenCard";
import { useWallet } from "../../context/walletProvider";
import { getAllTokens } from "../web3Wrapper";
import CircularProgress from '@material-ui/core/CircularProgress';

function CollectionContainer() {
  const [tokens, setTokens] = useState([]);
  const wallet = useWallet();
  useEffect(() => {
    async function getListedTokens() {
      if (wallet.status == "connected") {
        const res = await getAllTokens();
        console.log(res);
        setTokens(res);
      }
    }
    getListedTokens();
  }, [wallet]);
  return (
    <div className="nft-box-container">
      <Grid
        container
        style={{ alignItems: "center", margin: "auto", width: "80%", textAlign:'center' }}
      >
        {tokens.length ? (
          tokens.map((feature) => {
            return (
              <Grid item xs={12} sm={4}>
                <Card
                  header={feature.tokenId}
                  imageUrl={feature.imageUrl}
                  message={feature.tokenAddress}
                  nonce={feature.nonce}
                  fxnAddress={feature.fxnAddress}
                  buttonMessage="TRADE"
                />
              </Grid>
            );
          })
        ) : (
          <span
            style={{ margin:'auto',marginTop: "40%", fontSize: "1.5em", color: "#E0E0E0" }}
          >
            {(wallet.status!='connected')?'Switch to Rinkeby test network and connect wallet to continue':<CircularProgress/>}
          </span>
        )}
      </Grid>
    </div>
  );
}

export default CollectionContainer;
